import { render } from "./footers.vue?vue&type=template&id=7c391cba&scoped=true"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"

import "./footers.vue?vue&type=style&index=0&id=7c391cba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c391cba"]])

export default __exports__